import { useState, useEffect, useCallback, memo } from 'react';
import { Box, Typography, Switch } from '@mui/material';
import { validateField } from '../../../util/validation';

const EditableBoolean = memo(function EditableBoolean({
  value,
  setValue,
  isDialog = false,
  required = false,
  schema = null,
  readOnly = false,
  label = null,
  showLabel = false,
}) {
  const [tempValue, setTempValue] = useState(value);

  // update tempValue when value changes
  useEffect(() => {
    setTempValue(value);
  }, [value]);

  const handleSwitchChange = useCallback(
    async event => {
      const newValue = event.target.checked;
      setTempValue(newValue);

      if (schema && schema.type !== 'boolean') {
        const validation = validateField(newValue, schema);
        if (!validation.isValid) {
          return;
        }
      }

      if (isDialog) {
        setValue(newValue);
      } else {
        const result = await setValue(newValue);
        if (result !== true) {
          setTempValue(value);
        }
      }
    },
    [setValue, value, schema, isDialog]
  );

  const renderDisplay = useCallback(() => {
    const displayContent = value ? 'Ja' : 'Nein';

    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          p: 1,
          borderRadius: 1,
          position: 'relative',
          width: '100%',
          minHeight: '40px',
        }}
      >
        <Typography sx={{ flex: 1 }}>{displayContent}</Typography>
      </Box>
    );
  }, [value]);

  const renderEdit = useCallback(() => {
    return (
      <Box onClick={e => e.stopPropagation()}>
        {showLabel ? (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Switch
              checked={tempValue || false}
              onChange={handleSwitchChange}
              color='success'
              required={required}
            />
            <Typography variant='body2' color='text.secondary'>
              {label}
            </Typography>
          </Box>
        ) : (
          <Switch
            checked={tempValue || false}
            onChange={handleSwitchChange}
            color='success'
            required={required}
          />
        )}
      </Box>
    );
  }, [tempValue, handleSwitchChange, required, showLabel, label]);

  if (isDialog) {
    return renderEdit();
  }

  if (readOnly) {
    return renderDisplay();
  }

  return renderEdit();
});

export default EditableBoolean;
